import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ESTATUS_CHECKIN } from '@app/enums';
import { Passenger } from "@app/models/micro/passenger.model";
// import { SeatMap } from "@models/seatMap.model";
// import { GlobalsService } from "@services/globals.service";
import { GlobalsService as GlobalsServiceMicro } from '@app/services/micro/globals.service';
import { truncateText } from "@app/utils";
import { KioskPermissionsService } from '@services/kiosk-permissions.service';
// import { PNRLookupAWSInt } from '@app/interfaces/reservation-aws.interface';
/**
  Componente que representa un botón de selección de pasajero durante el proceso de check-in.
  Este componente muestra información relevante del pasajero, como su estado de check-in,
  y permite seleccionar o editar al pasajero. También gestiona la lógica de deshabilitación
  y visualización de íconos según el estado del pasajero.
**/
// export type TypeTemplateButton = 'passenger' | 'bags';
@Component({
    selector: 'am-passenger-button-select',
    templateUrl: './ampassenger-button-select.component.html',
    styleUrls: ['./ampassenger-button-select.component.scss'],
    standalone: false
})
export class AmpassengerButtonSelectComponent implements OnInit {
  /**
     Información del pasajero que se mostrará en el botón.
     @type {Passenger}
   **/
  @Input() passanger: Passenger;

  /**
    Color del texto que se aplicará según la familia de tarifas.
    @type {string}
  **/
  @Input() fareFamilyTextColor: string;

  /**
    Evento que se emite cuando se selecciona o deselecciona al pasajero.
    @type {EventEmitter<any>}
  **/
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  /**
    Evento que se emite cuando se solicita editar la información del pasajero.
    @type {EventEmitter<any>}
  **/
  @Output() edit: EventEmitter<any> = new EventEmitter<any>();

  /**
    Indica si el estado del pasajero está cargando.
    @type {boolean}
    @default true
  **/
  @Input() loadingStatusPassenger = true;

  @Input() ffnScreen = false;

  @Input() isVerPass = false;
  @Input() isFlowMYBClosed = false;

  constructor(
    public _globalsServiceMicro: GlobalsServiceMicro,
    protected _kioskPermissions: KioskPermissionsService
  ) {}

  ngOnInit(): void {
    console.log('_globalsServiceMicro', this._globalsServiceMicro)
    const reservation = this._globalsServiceMicro.getReservation();
    this.passanger.changeStatus(reservation);
    //this.passengers = this._global.getPassengers();
  }

   /**
    Obtiene el texto traducido correspondiente al estado de check-in del pasajero.
    @return {string} Texto traducido del estado de check-in.
  **/
  get copyEstatus() {
    const hasNoChekin = this.hasNotCheckin();
    if (hasNoChekin) {
      return 'passengerSelection.passengerButton.noElegibleToCheckin';
    }
    let copys = {}
    copys = {
      [ESTATUS_CHECKIN.HAS_CHEKIN]: 'passengerSelection.passengerButton.hasChekin',
      [ESTATUS_CHECKIN.READY_FOR_CHECKIN]: 'passengerSelection.passengerButton.readyForCheckin',
      [ESTATUS_CHECKIN.NOT_DOCUMENTS]: 'passengerSelection.passengerButton.notDocuments',
      [ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN]: 'passengerSelection.passengerButton.noElegibleToCheckin',
      [ESTATUS_CHECKIN.VERIFY_PASSPORT]: 'modalVerPass.titlePassengers',
      [ESTATUS_CHECKIN.MAX_PASSENGERS]: 'passengerSelection.passengerButton.maxPassengers',
    }
    if(this.isFlowMYBClosed && this.passanger.estatusCheckin === ESTATUS_CHECKIN.READY_FOR_CHECKIN) {
      return 'passengerSelection.passengerButton.documentsFFn';
    }else{
      return copys[this.passanger.estatusCheckin];
    }
  }
  /**
    Obtiene la ruta del ícono correspondiente al estado de check-in del pasajero.
    @return {string} Ruta del ícono.
  **/
  get getIconEstatus() {
    const hasNoChekin = this.hasNotCheckin();
    if (hasNoChekin) {
      return './assets/images/formIncorrect.svg';
    }
    let icons = {}
    icons = {
      [ESTATUS_CHECKIN.HAS_CHEKIN]: './assets/images/formCorrect.svg',
      [ESTATUS_CHECKIN.READY_FOR_CHECKIN]: './assets/images/formCorrect.svg',
      [ESTATUS_CHECKIN.NOT_DOCUMENTS]: './assets/images/formIncorrect.svg',
      [ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN]: './assets/images/formIncorrect.svg',
      [ESTATUS_CHECKIN.VERIFY_PASSPORT]: './assets/images/alertBlue.svg',
      [ESTATUS_CHECKIN.MAX_PASSENGERS]: './assets/images/formIncorrect.svg',
    }
    return icons[this.passanger.estatusCheckin];
  }
  /**
    Indica si el botón de selección debe estar deshabilitado según el estado de check-in del pasajero.
    @return {boolean} `true` si el botón debe estar deshabilitado, `false` en caso contrario.
  **/
  get isDisabled() {
    const hasNoChekin = this.hasNotCheckin();
    if (hasNoChekin) {
      return true;
    }
    let disabled = {}
    disabled = {
      [ESTATUS_CHECKIN.HAS_CHEKIN]: false,
      [ESTATUS_CHECKIN.READY_FOR_CHECKIN]: false,
      [ESTATUS_CHECKIN.NOT_DOCUMENTS]: false,
      [ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN]: true,
      [ESTATUS_CHECKIN.MAX_PASSENGERS]: true,
    }
    return disabled[this.passanger.estatusCheckin];
  }

  hasNotCheckin() {
    // Verificar primero si el flujo de check-in está habilitado en el kiosko
    if (!this._kioskPermissions.hasPermission('enableCheckInFlow') && !this.passanger.checkinStatus) {
      return true; // Check-in no disponible en este kiosko
    }

    return false;
  }
  /**
    Indica si se debe mostrar la opción de editar al pasajero según su estado de check-in.
    @return {boolean} `true` si se debe mostrar la opción de editar, `false` en caso contrario.
  **/
  get showEdit() {
    /* const showEdit = {
      [ESTATUS_CHECKIN.HAS_CHEKIN]: false,
      [ESTATUS_CHECKIN.READY_FOR_CHECKIN]: false,
      [ESTATUS_CHECKIN.NOT_DOCUMENTS]: false,
      [ESTATUS_CHECKIN.NO_ELEGIBLE_TO_CHECKIN]: false,
      [ESTATUS_CHECKIN.VERIFY_PASSPORT]: false,
    }
    if (this.passanger?.isOkToBoard && !this.passanger.checkinStatus && !this.passanger.hasVerifyDocument) {
      return this.passanger?.isOkToBoard
    }
    return showEdit[this.passanger.estatusCheckin]; */
    if (this.isFlowMYBClosed) {
      return true;
    }
    return false;
  }
  /**
    Indica si el pasajero que le faltan documentos.
    @return {boolean} `true` si el pasajero está listo para el check-in, `false` en caso contrario.
  **/
    get isNotDocuments() {
      return this.passanger.estatusCheckin == ESTATUS_CHECKIN.NOT_DOCUMENTS;
    }
  /**
    Indica si el pasajero está listo para el check-in.
    @return {boolean} `true` si el pasajero está listo para el check-in, `false` en caso contrario.
  **/
  get isReadyForCheckIn() {
    return this.passanger.estatusCheckin == ESTATUS_CHECKIN.READY_FOR_CHECKIN;
  }
  /**
    Indica si el pasajero ya ha realizado el check-in.
    @return {boolean} `true` si el pasajero ya ha realizado el check-in, `false` en caso contrario.
  **/
  get isHasCheckin() {
    return this.passanger.estatusCheckin == ESTATUS_CHECKIN.HAS_CHEKIN;
  }
  /**
    Indica si el pasajero tiene un infante asociado.
    @return {boolean} `true` si el pasajero tiene un infante, `false` en caso contrario.
  **/
  get hasInfant() {
    return !!this.passanger.ssrs.find(ssr => ssr.code === 'INFT');
  }
  /**
    Obtiene el texto del botón de edición o adición según el estado de check-in del pasajero.
    @return {string} Texto del botón.
  **/
  getCopyButton() {
    if(this.isVerPass){
      return `modalVerPass.pssbutton`
    }else{
       if (this.isFlowMYBClosed) {
          return "passengerSelection.passengerButton.edit";
      }
      return `passengerSelection.passengerButton.${this.passanger.estatusCheckin === ESTATUS_CHECKIN.NOT_DOCUMENTS ? "add" : "edit"}`
    }
  }
    /**
    Maneja el evento de selección o deselección del pasajero.
    @param {boolean} select - Indica si el pasajero ha sido seleccionado (`true`) o deseleccionado (`false`).
    @return void
  **/
  onSelect(select: boolean) {
    this.passanger.isSelectedToCheckin = select;
    this.selected.emit(select);
  }
 /**
    Maneja el evento de edición del pasajero.
    @return void
  **/
  onEdit() {
    this.edit.emit(this.passanger);
  }
  /**
    Trunca un texto a una longitud máxima especificada.
    @param {string} elementTXt - Texto a truncar.
    @param {string} maxLength - Longitud máxima del texto truncado.
    @return {string} Texto truncado.
  **/
  truncateTextUi(elementTXt, maxLength = '20') {
    return truncateText(elementTXt, maxLength)
  }
  //#endregion Eventos
}
